const isDuplicated = (value, compareValue = value) =>
  !value || !compareValue || value === compareValue ? 'Este valor é duplicado!' : undefined;

export default isDuplicated;
